export class ContactData {
    private _inscriptionId: string;
    private _email: string;
    private _phoneNumber1: number;
    private _phoneNumber2: number;
    private _inscriptionTurn: number;
    private _examsLanguageSelected: string;

    constructor(data: any, inscriptionId?) {
        this._inscriptionId = inscriptionId;
        this._email = data.email;
        this._phoneNumber1 = data.phoneNumber1;
        this._phoneNumber2 = data.phoneNumber2;
        this._inscriptionTurn = data.inscriptionTurn;
        this._examsLanguageSelected = data.examsLanguageSelected;
    }

    public get inscriptionId() {
        return this._inscriptionId;
    }

    public set inscriptionId(inscriptionId: string) {
        this._inscriptionId = inscriptionId;
    }

    public get email() {
        return this._email;
    }

    public set email(email: string) {
        this._email = email;
    }

    public get phoneNumber1() {
        return this._phoneNumber1;
    }

    public set phoneNumber1(phoneNumber1: number) {
        this._phoneNumber1 = phoneNumber1;
    }

    public get phoneNumber2() {
        return this._phoneNumber2;
    }

    public set phoneNumber2(phoneNumber2: number) {
        this._phoneNumber2 = phoneNumber2;
    }

    public get inscriptionTurn() {
        return this._inscriptionTurn;
    }
    public set inscriptionTurn(inscriptionTurn: number) {
        this._inscriptionTurn = inscriptionTurn;
    }

    public get examsLanguageSelected() {
        return this._examsLanguageSelected;
    }
    public set examsLanguageSelected(examsLanguageSelected: string) {
        this._examsLanguageSelected = examsLanguageSelected;
    }

    public updateContactData(dataEdited) {
        this._email = dataEdited.email;
        this._phoneNumber1 = dataEdited.phoneNumber1;
        this._phoneNumber2 = dataEdited.phoneNumber2;
    }
    public toServer() {
        return {
            inscriptionId: this._inscriptionId,
            email: this._email,
            phoneNumber1: this._phoneNumber1,
            phoneNumber2: this._phoneNumber2,
        }
    }
    public toServerInscription() {
        return {
            email: this._email,
            phoneNumber1: this._phoneNumber1,
            phoneNumber2: this._phoneNumber2,
            inscriptionTurn: this._inscriptionTurn,
            examsLanguageSelected: this._examsLanguageSelected
        }
    }
}
